import { render, staticRenderFns } from "./IAppContent.vue?vue&type=template&id=0e46776a&"
import script from "./IAppContent.vue?vue&type=script&lang=js&"
export * from "./IAppContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports